// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"42":"8c4afe9d","44":"9952e8e8","72":"a9b781cd","173":"8fadc435","401":"3238388f","470":"0f689f18","520":"e778644b","627":"e0c39ced","677":"d9abcf90","814":"f33d2858","815":"d10932aa"}[chunkId] + ".chunk.js";
};